import { useEffect, useState } from 'react';
import './SearchBar.css';
import useDebounce from '../../hooks/useDebounce';
import Input from '../Inputs/Input';
export const SearchBar = ({onChange}) => {
    const [value, setvalue] = useState("");
    let debouncedValue = useDebounce(value, 300);

    useEffect(()=>{
        onChange(debouncedValue);
    },[debouncedValue]);

    return(<Input onSuffixIconClick={()=>{if(Boolean(value)) setvalue("")}} suffixIcon={Boolean(value) ? "icon-light-cross" : "icon-search"} value={value} onChange={(e) => setvalue(e.target.value)} label="" placeholder="Search" />)

}